import { render, staticRenderFns } from "./FieldDetail.vue?vue&type=template&id=446cc7b6&scoped=true"
import script from "./FieldDetail.vue?vue&type=script&lang=js"
export * from "./FieldDetail.vue?vue&type=script&lang=js"
import style0 from "./FieldDetail.vue?vue&type=style&index=0&id=446cc7b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446cc7b6",
  null
  
)

export default component.exports